import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { ConfigService } from "@archipad-js/core/config";

import { query } from "@archipad-js/core/orm";

import { ProjectEntity } from "@archipad-js/archipad-model";
import { WorkPackageEntity } from "@archipad-js/archipad-model";

export class WorkPackageService {
    /**
     * Emits a list of work package index and name suggestions.
     *
     * @example
     * [
     *   {"index": "300", "name": "Gros Œuvre"}
     * ]
     */
    readonly indexAndNameSuggestions$: Observable<readonly WorkPackageSuggestion[]>;

    constructor(private readonly configService: ConfigService) {
        this.indexAndNameSuggestions$ = this.configService.getObservable("wp_index_description").pipe(
            map((suggestions) => {
                if (suggestions === null) {
                    return [];
                }

                return (suggestions as { data: readonly WorkPackageSuggestion[] }).data;
            }),
            shareReplay(1),
        );
    }

    public listWorkPackages(options: {
        where: { project: ProjectEntity; withContact?: boolean };
    }): readonly WorkPackageEntity[] {
        const { project, withContact } = options.where;
        const entityContext = project.getContext();

        const q = query(entityContext, "WorkPackage");

        if (withContact) {
            q.predicateWithFormat("contact != null");
        }

        q.orderBy("index(natural), name(natural), contact.company(natural), contact.name(natural), id");

        const workPackages = q.execute().sortedEntities();

        return workPackages;
    }
}

interface WorkPackageSuggestion {
    index: WorkPackageEntity["index"];
    name: WorkPackageEntity["name"];
}
